import { useState, useEffect } from "react";
var options = {
    enableHighAccuracy: false,
    timeout: Infinity,
    maximumAge: 0
};
const useGeoLocation = () => {
    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: 0, lng: 0 },
        isloading: true,
        error: {
            code: "",
            message: "",
        }
    });

    const onSuccess = (location) => {
        setLocation({
            loaded: true,
            isloading: false,
            coordinates: {
                lat: location.coords.latitude,
                lng: location.coords.longitude,
            },
            error: {
                code: "",
                message: "",
            }
        });
    };

    const onError = (error) => {
        setLocation({
            loaded: true,
            isloading: false,
            error: {
                code: error.code,
                message: error.message,
            },
        });
    };

    useEffect(() => {
        // if the browser does not support geo-location (unlikely)
        if (!("geolocation" in navigator)) {
            onError({
                code: 0,
                message: "Geolocation not supported",
            });
        }

        navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
    }, []);

    return location;
};

export default useGeoLocation;
